import * as apiTo from '@/modular-api'

export default {
  namespaced: true,

  state: () => ({
    totalRows: 0,
    rowsSelected: [],
    selectAll: false,
    overviewData: null,
    filterInProgress: false
  }),

  mutations: {
    setTotalRows: (state, payload) => (state.totalRows = payload),
    setRowsSelected: (state, payload) => (state.rowsSelected = payload),
    setSelectAll: (state, payload) => (state.selectAll = payload),
    setOverviewData: (state, payload) => (state.overviewData = payload),
    setFilterInProgress: (state, payload) => (state.filterInProgress = payload)
  },

  actions: {
    getAndSetOverviewData({ commit, rootState }) {
      const financialPeriod = rootState.predictions.financialPeriodId
      if (!financialPeriod) return

      apiTo
        .GET_INFO_BOX_FORECASTED_SUBSCRIPTION_COST_OVERVIEW(financialPeriod)
        .then(({ data }) => commit('setOverviewData', data.result))
    }
  }
}
